module.exports = __webpack_public_path__ + "static/media/buttons-icon-buttons-24-more.bb4985aa.svg";